import React from 'react';
import PropTypes from 'prop-types';
import { PopoverItem } from '../ui/Popover';
import { qa } from '../api';

const ReopenIssue = ({ projectID, issue, doAction }) => (
  <PopoverItem
    label="Reopen"
    onClick={() => doAction(qa.reopenIssue(projectID, issue.id))}
  />
);

ReopenIssue.propTypes = {
  projectID: PropTypes.string.isRequired,
  issue: PropTypes.object.isRequired,
  doAction: PropTypes.func.isRequired,
};

export default ReopenIssue;
